const a = {
  body: "Barlow, Barlow-fallback, sans-serif",
  heading: "'Barlow Condensed','Barlow Condensed-fallback', sans-serif"
};
export {
  a as default
};
